
export class AchEnrollmentAppConstants {
    public static readonly ACH_ENROLLMENT_TYPE = 'ACH_ENROLLMENT';
}